export default "__VITE_ASSET__CSQmmR8z__"